import React, { useRef, useState } from 'react'
import LoginWrapper from './SignInProductManagement.styled.jsx'
import { FormattedMessage } from 'react-intl'
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { BsFillEnvelopeOpenFill, BsUnlockFill } from 'react-icons/bs'
// import { faEnvelope, faUnlockAlt } from "@fortawesome/free-solid-svg-icons";
import { Button } from '@themesberg/react-bootstrap'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import { InputText } from 'primereact/inputtext'
import * as Yup from 'yup'
import useRequest from '../../../axios/apis/useRequest.js'
import { Routes } from '../../../routes.js'
import { useNavigate } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import ReCAPTCHA from 'react-google-recaptcha'
import SafeFormatMessage from '../Shared/SafeFormatMessage/SafeFormatMessage.jsx'
const SignInProductManagement = () => {
  const [recaptchaToken, setRecaptchaToken] = useState(null)
  const recaptchaRef = useRef(null)
  const redirectPath = useSelector(
    (state) => state.auth.redirectPath?.redirectPath
  )

  const { SignInProductOwnerAsync } = useRequest()
  const navigate = useNavigate()
  const initialValues = {
    email: '',
    password: '',
  }

  const validationSchema = Yup.object().shape({
    email: Yup.string().email('Invalid email').required('Email is required'),
    password: Yup.string().required('Password is required'),
  })

  const handleSubmit = async (values, { setSubmitting, setErrors }) => {
    if (!recaptchaToken) {
      setErrors({ recaptcha: 'Please complete the reCAPTCHA' })
      setSubmitting(false)
      return
    }

    try {
      const loginPass = await SignInProductOwnerAsync({
        ...values,
        recaptchaToken,
      })

      if (loginPass) {
        redirectPath
          ? navigate(redirectPath)
          : loginPass.data.data.userAccount.userType == 4
            ? navigate(Routes.workSpace.path)
            : navigate(Routes.Dashboard.path)
      }
    } catch (error) {
      // Handle login error here
      console.error(error)
    } finally {
      // Reset reCAPTCHA regardless of success or failure
      if (recaptchaRef.current) {
        recaptchaRef.current.reset()
      }
      setSubmitting(false)
    }
  }

  const onRecaptchaChange = (token) => {
    setRecaptchaToken(token)
  }

  return (
    <LoginWrapper>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting, errors }) => (
          <Form className="mt-4">
            <div>
              <label htmlFor="email" className="pb-2">
                <SafeFormatMessage id="yourEmail" />
              </label>
              <div className="inputContainer">
                <div className="inputContainerWithIcon">
                  <BsFillEnvelopeOpenFill />
                  <Field type="email" id="email" name="email" as={InputText} />
                </div>
                <ErrorMessage
                  name="email"
                  component="div"
                  className="error-message"
                />
              </div>
            </div>
            <div>
              <label htmlFor="password" className="pb-2">
                <SafeFormatMessage id="yourPassword" />
              </label>
              <div className="inputContainer">
                <div className="inputContainerWithIcon">
                  <BsUnlockFill />
                  <Field
                    type="password"
                    id="password"
                    name="password"
                    as={InputText}
                  />
                </div>

                <div className="d-flex justify-content-between">
                  <div>
                    <ErrorMessage
                      name="password"
                      component="div"
                      className="error-message"
                    />
                  </div>
                  <div
                    className="mt-1 mx-2"
                    style={{ color: 'var(--second-color)' }}
                  >
                    <Link
                      to={Routes.ResetPasswordRequest.path}
                      className="link-underline"
                    >
                      <SafeFormatMessage id="forgotPassword?" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="recaptcha-container mt-2 mb-4">
              <div>
                <ReCAPTCHA
                  ref={recaptchaRef}
                  sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                  onChange={onRecaptchaChange}
                />
                <div className="error-message">
                  {errors.recaptcha && <div>{errors.recaptcha}</div>}
                </div>
              </div>
            </div>
            <div className="pt-1">
              <Button
                variant="primary"
                type="submit"
                className="w-100"
                disabled={isSubmitting}
              >
                <SafeFormatMessage id="signIn" />
              </Button>
            </div>
            <div className="pt-2 text-center">
              <span>
                <SafeFormatMessage id="join-as-product-owner" />
              </span>{' '}
              <Link
                className="link-underline "
                to="https://dashboard.rosaas.app/marketplace/roaa-tech/rosaas"
              >
                <SafeFormatMessage id="Sign-up-your-product-today!" />
              </Link>
            </div>
          </Form>
        )}
      </Formik>
    </LoginWrapper>
  )
}

export default SignInProductManagement
